export const pageBuilderLivePreviewDocsUrl =
  "https://prismic.io/docs/page-builder#enable-live-previews"
